import React, { useState, useEffect } from 'react';

const OneSolarThanksYou: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Get user's first name and email from localStorage
  const firstName = localStorage.getItem('q9-firstname') || 'Friend';
  const email = localStorage.getItem('q11-email') || 'your email';

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const styles = {
    header: {
      backgroundColor: '#fff',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      position: 'sticky' as const,
      top: 0,
      zIndex: 100,
    },
    nav: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 'auto',
    },
    logo: {
      fontSize: '26px',
      fontWeight: '700',
      color: '#1a365d',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: 0,
      margin: 0,
      lineHeight: 0,
    },
    hamburger: {
      display: 'none',
      flexDirection: 'column' as const,
      gap: '4px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '5px',
    },
    hamburgerLine: {
      width: '25px',
      height: '3px',
      backgroundColor: '#333',
      transition: 'all 0.3s',
    }
  };

  return (
    <div style={{
      fontFamily: '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      color: '#2c3e50',
      backgroundColor: '#ffffff',
      minHeight: '100vh',
      padding: 0,
      margin: 0
    }}>
      {/* Header Navigation */}
      <header style={styles.header}>
        {/* Navigation */}
        <nav style={{...styles.nav, position: 'relative' as const, flexWrap: isMobile ? 'wrap' : 'nowrap'}}>
          <a href="/" style={{...styles.logo, display: 'flex', alignItems: 'center', textDecoration: 'none'}}>
            <img src="/assets/onepropertyaustralia/logo.png" alt="One Solar Incentives" style={{ height: isMobile ? '60px' : '80px', display: 'block' }} />
          </a>
          
          {!isMobile && (
            <span style={{ 
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              fontSize: '24px', 
              fontWeight: 'bold', 
              color: '#141D46', 
              fontFamily: "'Open Sans', sans-serif", 
              whiteSpace: 'nowrap' 
            }}>#The Australian Rebate Specialists</span>
          )}
          
          <img 
            src="/assets/easypropertyinvestorimages/ssllogo.png" 
            alt="SSL Secured" 
            style={{ 
              height: isMobile ? '30px' : '40px', 
              marginLeft: 'auto',
              marginRight: isMobile ? '10px' : '20px'
            }} 
          />
          
          <button
            style={styles.hamburger}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span style={styles.hamburgerLine}></span>
            <span style={styles.hamburgerLine}></span>
            <span style={styles.hamburgerLine}></span>
          </button>
          
          {isMobile && (
            <div style={{ 
              width: '100%',
              textAlign: 'center',
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#141D46',
              fontFamily: "'Open Sans', sans-serif",
              whiteSpace: 'nowrap',
              marginTop: '10px'
            }}>
              #The Australian Rebate Specialists
            </div>
          )}
        </nav>
        
        {/* Blue bar under nav */}
        <div style={{ 
          width: '100%', 
          height: isMobile ? '40px' : '35px', 
          backgroundColor: '#141D46',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: isMobile ? '12px' : '16px',
          fontWeight: '900',
          fontFamily: 'Gilroy',
          padding: isMobile ? '0 10px' : '0',
          overflow: 'hidden',
          whiteSpace: isMobile ? 'normal' : 'nowrap'
        }}>
          <img 
            src="/assets/easypropertyinvestorimages/star.png" 
            alt="5 stars" 
            style={{ 
              height: isMobile ? '14px' : '20px',
              marginRight: isMobile ? '5px' : '8px'
            }} 
          />
          <span>
            Government Rebates up to $5,350 Reducing Again in 2026
          </span>
        </div>
      </header>

      {/* Success Content */}
      <div style={{
        backgroundColor: 'transparent',
        padding: isMobile ? '40px 20px' : '60px 20px',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontSize: isMobile ? '36px' : '52px',
          fontWeight: '900',
          marginBottom: '20px',
          color: '#141D46',
          maxWidth: '800px',
          margin: '0 auto 20px',
          letterSpacing: '-0.5px',
          lineHeight: '1.2'
        }}>
          {firstName}, you're eligible for your federal government solar and battery rebates
        </h1>
      </div>

      {/* Video Section */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: isMobile ? '30px 20px' : '50px 20px',
        textAlign: 'center'
      }}>
        <h2 style={{
          fontSize: isMobile ? '22px' : '28px',
          marginBottom: '20px',
          color: '#141D46',
          fontWeight: 'bold'
        }}>
          Click the <span style={{ textDecoration: 'underline' }}>Play</span> button and <span style={{ textDecoration: 'underline' }}>Unmute</span> video for your next steps 👇
        </h2>
        
        {/* Video Placeholder */}
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          backgroundColor: '#000',
          aspectRatio: '16/9',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            backgroundColor: '#fff',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer'
          }}>
            <div style={{
              width: 0,
              height: 0,
              borderLeft: '30px solid #141D46',
              borderTop: '20px solid transparent',
              borderBottom: '20px solid transparent',
              marginLeft: '8px'
            }}></div>
          </div>
        </div>
      </div>

      {/* Email Confirmation */}
      <div style={{
        padding: isMobile ? '30px 20px' : '40px 20px',
        backgroundColor: '#ffffff',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <div style={{
          maxWidth: '800px',
          width: '100%',
          textAlign: 'left'
        }}>
          <p style={{
            fontSize: isMobile ? '16px' : '18px',
            color: '#333',
            marginBottom: '20px',
            textAlign: 'left'
          }}>
            An email has been sent to <strong>{email}</strong> with what happens next, so please check your inbox now.
          </p>
          
          <p style={{
            fontSize: isMobile ? '16px' : '18px',
            color: '#333',
            marginBottom: '30px',
            textAlign: 'left'
          }}>
            We're excited to help you join 4 million Aussies already saving up to 90% with solar and battery storage.
          </p>
          
          <div style={{
            fontSize: isMobile ? '18px' : '20px',
            color: '#141D46',
            fontWeight: 'bold',
            textAlign: 'left'
          }}>
            <p style={{ margin: '0 0 5px 0' }}>Dan</p>
            <p style={{ 
              fontSize: isMobile ? '16px' : '18px', 
              fontWeight: 'normal', 
              color: '#666',
              margin: 0
            }}>
              from Head of Rebate Success Team at One Solar Australia
            </p>
          </div>
        </div>
      </div>


      {/* Next Steps Section */}
      <div style={{
        padding: isMobile ? '40px 20px' : '60px 20px',
        backgroundColor: '#fff'
      }}>
        <h2 style={{
          fontSize: isMobile ? '28px' : '36px',
          fontWeight: 'bold',
          color: '#141D46',
          textAlign: 'center',
          marginBottom: '40px'
        }}>
          Next Steps...
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
          gap: '30px',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          {/* Step 1 - Expert Contact */}
          <div style={{
            textAlign: 'center',
            padding: '20px'
          }}>
            {/* Icon placeholder */}
            <div style={{
              width: '80px',
              height: '80px',
              backgroundColor: '#f0f0f0',
              borderRadius: '50%',
              margin: '0 auto 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '40px'
            }}>
              📞
            </div>
            <h3 style={{
              fontSize: isMobile ? '18px' : '20px',
              fontWeight: 'bold',
              color: '#141D46',
              marginBottom: '15px'
            }}>
              Step 1: Expert Contact
            </h3>
            <p style={{
              fontSize: isMobile ? '14px' : '16px',
              color: '#666',
              lineHeight: '1.6'
            }}>
              A solar specialist will call you shortly to confirm your rebate eligibility and schedule your free consultation
            </p>
          </div>
          
          {/* Step 2 - Your Custom Plan */}
          <div style={{
            textAlign: 'center',
            padding: '20px'
          }}>
            {/* Icon placeholder */}
            <div style={{
              width: '80px',
              height: '80px',
              backgroundColor: '#f0f0f0',
              borderRadius: '50%',
              margin: '0 auto 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '40px'
            }}>
              📋
            </div>
            <h3 style={{
              fontSize: isMobile ? '18px' : '20px',
              fontWeight: 'bold',
              color: '#141D46',
              marginBottom: '15px'
            }}>
              Step 2: Your Custom Plan
            </h3>
            <p style={{
              fontSize: isMobile ? '14px' : '16px',
              color: '#666',
              lineHeight: '1.6'
            }}>
              Get a clear breakdown of your savings potential and perfect solar solution. In simple, everyday terms
            </p>
          </div>
          
          {/* Step 3 - Easy Installation */}
          <div style={{
            textAlign: 'center',
            padding: '20px'
          }}>
            {/* Icon placeholder */}
            <div style={{
              width: '80px',
              height: '80px',
              backgroundColor: '#f0f0f0',
              borderRadius: '50%',
              margin: '0 auto 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '40px'
            }}>
              🔧
            </div>
            <h3 style={{
              fontSize: isMobile ? '18px' : '20px',
              fontWeight: 'bold',
              color: '#141D46',
              marginBottom: '15px'
            }}>
              Step 3: Easy Installation
            </h3>
            <p style={{
              fontSize: isMobile ? '14px' : '16px',
              color: '#666',
              lineHeight: '1.6'
            }}>
              Ready to save? Start with $0 down, while experts handle everything for a stress-free installation
            </p>
          </div>
        </div>
      </div>


      {/* Footer */}
      <footer style={{
        backgroundColor: '#fff',
        marginTop: '10px'
      }}>
        <div style={{
          borderTop: '1px solid #e2e8f0',
          padding: '40px 20px',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <div style={{
            display: 'flex',
            gap: isMobile ? '15px' : '30px',
            justifyContent: 'center',
            marginBottom: isMobile ? '20px' : '30px',
            flexWrap: 'wrap',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center'
          }}>
            <a href="/privacy-policy" style={{
              color: '#666',
              fontSize: isMobile ? '14px' : '18px',
              fontWeight: 'bold',
              textDecoration: 'none'
            }}>Privacy Policy</a>
            <a href="/terms-and-conditions" style={{
              color: '#666',
              fontSize: isMobile ? '14px' : '18px',
              fontWeight: 'bold',
              textDecoration: 'none'
            }}>Terms and Conditions</a>
            <a href="/cookie-policy" style={{
              color: '#666',
              fontSize: isMobile ? '14px' : '18px',
              fontWeight: 'bold',
              textDecoration: 'none'
            }}>Cookie Policy</a>
          </div>
          
          <div style={{
            color: '#666',
            fontSize: isMobile ? '10px' : '12px',
            lineHeight: '1.6',
            textAlign: 'justify',
            margin: '0 auto',
            padding: isMobile ? '0 10px' : '0'
          }}>
            <p>
              <a href="https://onesolarincentivesaustralia.com.au" style={{ color: '#a7a7a7', fontWeight: 'bold', textDecoration: 'none' }}>onesolarincentivesaustralia.com.au</a> is owned and operated by One Solar Incentives Australia Pty Ltd (ABN 27 147 278 153) (referred to as "we", "us", or "One Solar Incentives Australia"). The website may share your details with independent property and real estate consultants who may contact you to provide the services you have requested. You are not obligated to accept or engage with any of these services. By submitting your information through <a href="https://onesolarincentivesaustralia.com.au" style={{ color: '#a7a7a7', fontWeight: 'bold', textDecoration: 'none' }}>onesolarincentivesaustralia.com.au</a>, you consent to us providing your details to third parties and to being contacted by phone, SMS, or email regarding your enquiry. Please review our Privacy Policy for more details on how we manage and protect your information.
            </p>
            <p style={{ marginTop: '10px' }}>
              We do not provide financial product advice or financial dealing services, nor do we endorse financial products or issuers. Our role is to connect your enquiry with a third-party provider that may be able to offer comparisons across a variety of products, services, and providers. Before engaging any provider, you should carefully assess whether their services are appropriate for your financial situation, needs, and goals, and review their disclosure documents (such as their financial services guide). If you choose to proceed with a service offered after being referred via <a href="https://onesolarincentivesaustralia.com.au" style={{ color: '#a7a7a7', fontWeight: 'bold', textDecoration: 'none' }}>onesolarincentivesaustralia.com.au</a>, your dealings will be directly with that provider and not with One Solar Incentives Australia Pty Ltd.
            </p>
            <p style={{ marginTop: '10px' }}>
              We are not involved in delivering financial advice and take no responsibility for the services provided by third-party providers. To the fullest extent permitted by law, we are not liable for any loss or damage arising from your reliance on or use of services delivered by external providers. We also make no representation as to the quality, accuracy, or suitability of any financial advice offered by these third parties.
            </p>
            <p style={{ marginTop: '10px' }}>
              One Solar Incentives Australia Pty Ltd may receive a fixed referral fee when your details are passed on to relevant providers. This fee is not commission-based, is not dependent on the outcome of your enquiry, and does not vary based on any investment decisions you may make. While we aim to ensure all information presented on our website is current and accurate, there may be times when updates are required and some details may be temporarily out of date.
            </p>
          </div>
          
          <p style={{
            color: '#666',
            fontSize: '14px',
            margin: '30px 0 0 0',
            textAlign: 'center'
          }}>
            © 2025 One Solar Incentives Australia. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default OneSolarThanksYou;